import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=d8ae0002&scoped=true"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=d8ae0002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ae0002",
  null
  
)

export default component.exports